import JwtDecode from 'jwt-decode';

const tempData = {
  authToken: '',
}

const AuthPlugin = {
  setToken: function (token) {
    localStorage.setItem('authToken', token);
    tempData['authToken'] = token;
  },

  destroyToken: function () {
    localStorage.removeItem('authToken');
    tempData['authToken'] = '';
    localStorage.clear();
  },

  getToken: function () {
    const token = tempData['authToken'] || localStorage.getItem('authToken');
    if (!token) return false;

    return token;
  },

  getTokenData: function () {
    const token = this.getToken();
    if (!token) return false;

    return JwtDecode(token);
  },

  loggedIn: function (type = false) {
    const data = this.getTokenData();
    if (!data) return false;
    return !(type && data.type !== type);
  },
};

export default function (Vue) {
  Vue.auth = AuthPlugin;

  Object.defineProperties(Vue.prototype, {
    $auth: {
      get: function () {
        return Vue.auth;
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/plugins/auth.js